export default "__VITE_ASSET__BkTPc8yQ__"